import React from "react";
import { Link, useParams } from "react-router-dom";
import {
  FaCheckCircle,
  FaArrowRight,
  FaWhatsapp,
  FaPhoneAlt,
  FaTools,
} from "react-icons/fa";

import { servicesData } from "../../data/servicesData";
import { siteData } from "../../data/siteData";

import "./ServiceDetails.css";

function ServiceDetails() {
  const { slug } = useParams();

  const service = servicesData.find(
    (service) => service.slug === slug
  );

  // If URL doesn't match any service
  if (!service) {
    return (
      <section className="service-not-found">
        <div className="container text-center">
          <FaTools className="not-found-icon" />

          <h2>Service Not Found</h2>

          <p>
            The service you are looking for could not be found.
          </p>

          <Link to="/services" className="btn back-services-btn">
            Back To Services
          </Link>
        </div>
      </section>
    );
  }

  return (
    <main className="service-details-page">

      {/* Hero */}
      <section className="service-details-hero">
        <div className="container">
          <div
            className="service-details-hero-content"
            data-aos="fade-up"
          >
            <div className="service-details-icon">
              {service.icon}
            </div>

            <span className="section-badge">
              Mobile Repair Service
            </span>

            <h1>{service.title}</h1>

            <p>{service.shortDescription}</p>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="service-overview-section">
        <div className="container">
          <div className="row align-items-center">

            <div
              className="col-lg-7 mb-4 mb-lg-0"
              data-aos="fade-right"
            >
              <span className="section-badge">
                Service Overview
              </span>

              <h2 className="section-title text-start">
                Professional {service.title}
              </h2>

              <p className="service-overview-text">
                {service.description}
              </p>

              <p className="service-overview-text">
                Our technicians inspect the device to identify the
                cause of the problem before proceeding with the
                appropriate repair solution.
              </p>
            </div>

            <div
              className="col-lg-5"
              data-aos="fade-left"
            >
              <div className="service-highlight-box">
                <div className="highlight-icon">
                  {service.icon}
                </div>

                <h3>{service.title}</h3>

                <p>
                  Professional mobile repair at your location
                  across the UAE.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Problems */}
      <section className="service-problems-section">
        <div className="container">

          <div
            className="section-heading text-center"
            data-aos="fade-up"
          >
            <span className="section-badge">
              Common Problems
            </span>

            <h2 className="section-title">
              Problems We Can Help With
            </h2>

            <p className="section-description">
              These are some of the common issues associated with{" "}
              {service.title.toLowerCase()}.
            </p>
          </div>

          <div className="row justify-content-center">
            {service.problems.map((problem, index) => (
              <div
                className="col-lg-4 col-md-6 mb-3"
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 80}
              >
                <div className="problem-item">
                  <FaCheckCircle />
                  <span>{problem}</span>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      {/* Benefits */}
      <section className="service-benefits-section">
        <div className="container">

          <div className="row align-items-center">

            <div
              className="col-lg-6 mb-4 mb-lg-0"
              data-aos="fade-right"
            >
              <div className="benefits-box">
                <div className="benefits-icon">
                  {service.icon}
                </div>

                <h3>Our {service.title} Service</h3>

                <p>
                  We focus on careful diagnosis, professional
                  repair, and testing the device after the repair.
                </p>
              </div>
            </div>

            <div
              className="col-lg-6"
              data-aos="fade-left"
            >
              <span className="section-badge">
                What You Get
              </span>

              <h2 className="section-title text-start">
                What Our Service Includes
              </h2>

              <div className="benefits-list">
                {service.benefits.map((benefit, index) => (
                  <div
                    className="benefit-item"
                    key={index}
                  >
                    <FaCheckCircle />
                    <span>{benefit}</span>
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="service-details-cta">
        <div className="container">
          <div
            className="service-cta-card"
            data-aos="zoom-in"
          >
            <FaTools className="cta-tools-icon" />

            <h2>Need {service.title}?</h2>

            <p>
              Contact MR. MOB FIXER and get help with your mobile
              repair issue.
            </p>

            <div className="service-cta-buttons">

              <a
                href={`https://wa.me/${siteData.whatsapp.replace(
                  "+",
                  ""
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn service-whatsapp-btn"
              >
                <FaWhatsapp />
                WhatsApp Us
              </a>

              <a
                href={`tel:${siteData.phone}`}
                className="btn service-call-btn"
              >
                <FaPhoneAlt />
                Call Now
              </a>

            </div>
          </div>
        </div>
      </section>

      {/* Back to services */}
      <div className="back-to-services">
        <Link to="/services">
          <FaArrowRight />
          View All Services
        </Link>
      </div>

    </main>
  );
}

export default ServiceDetails;